export default class PongChatvisorBrokerAction {
  constructor(username) {
    this.action = 'PongChatvisorBrokerAction';
    this.username = username;
    this.client = `AGENT-${username}`;
  }
}
